import styled from 'styled-components';

const OptionsStepContainer = styled.div`
        display: 'flex';
        flex-direction: 'row'
`;

export default OptionsStepContainer;
